import tippy from 'tippy.js'

export default {
  mounted() {
    const tip = tippy(this.el, {
      content(reference) {
        const id = reference.getAttribute('data-tippy-template');
        const template = document.getElementById(id);
        return template.innerHTML;
      },
      trigger: 'click',
      hideOnClick: true,
      duration: [300, 250],
      placement: 'bottom-start',
      interactive: true,
      allowHTML: true,
      maxWidth: '224px',
      interactiveDebounce: 100,
      animation: 'fade',
      arrow: false,
      theme: 'ai-source',
      onShow(instance) {
        instance.reference.classList.add('bg-tertiary');
      },
      onHide(instance) {
        instance.reference.classList.remove('bg-tertiary');
      },
      onCreate(instance) {
        const id = instance.reference.getAttribute('data-tippy-template');
        const service = instance.reference.getAttribute('data-service');
        const title = instance.reference.getAttribute('data-title');
        const value = instance.reference.getAttribute('data-value');
        const field = instance.reference.getAttribute('data-field');
        const object = instance.reference.getAttribute('data-object');
        const serviceIconPath = instance.reference.getAttribute('data-logo');
        const href = instance.reference.getAttribute('data-href');
        const date = instance.reference.getAttribute('data-date');
        if (id) {
          const template = document.getElementById(id);
          if (template) {
            instance.setContent(template.innerHTML);

            // After setting content, we can find elements within the tippy instance's popper
            const tippyContent = instance.popper.querySelector('.tippy-content');
            const valueElement = tippyContent.querySelector('#ai-source-tooltip-value')
            const fieldElement = tippyContent.querySelector('#ai-source-tooltip-field')
            const fieldObjectElement = tippyContent.querySelector('#ai-source-tooltip-object')
            const logo = tippyContent.querySelector('#ai-source-tooltip-service img')
            const link = tippyContent.querySelector('#ai-source-tooltip-link')
            // Now we can safely manipulate these elements if needed
            if (!title) {
              valueElement.textContent = value;
              fieldElement.textContent = `(${field})`;
              fieldObjectElement.textContent = object;
            } else {
              fieldObjectElement.textContent = title;
              valueElement.textContent = date;
              fieldElement.textContent = '';
            }
            logo.src = serviceIconPath
            link.href = href
            // If source is not from Jump, open in new tab
            if (service !== 'jump') {
              link.target = '_blank'
            }
          }
        }
      },
    });

    // Store reference to the tippy instance for potential cleanup
    this.tippyInstance = tip;
  },

  // Clean up when component is unmounted
  destroyed() {
    if (this.tippyInstance) {
      this.tippyInstance.destroy();
    }
  }
}
